/* All the commonly used functionality */
import CustomisationTypes = Infospeed.FrontEnd.COT.CustomisationTypes;
import RegistrationAnalysis = Infospeed.Services.ClassWeb.API.Contracts.COT.RegistrationAnalysis
import AnalysisUDFItem = Infospeed.Services.ClassWeb.API.Contracts.COT.AnalysisUDFItem;
import IFlywireTheme = Infospeed.FrontEnd.COT.IFlywireTheme;
import IFlywireConfig = Infospeed.FrontEnd.COT.IFlywireConfig;

import { Injectable, OnDestroy } from '@angular/core';
import { NativeDateAdapter } from '@angular/material';
import { Subject } from 'rxjs/Subject';
import { Subscription } from "rxjs/Subscription";
import { MediaChange, ObservableMedia } from "@angular/flex-layout";
import { DomSanitizer } from '@angular/platform-browser';
import { IDropdownSelectOption, DropdownService } from "../widgets/dropdown/dropdown.component";
import { ValidatorFn, AbstractControl } from '@angular/forms';

@Injectable()
export class CommonUtilityService {
    private flywireTheme: IFlywireTheme = { Header: true, BackgroundColor: '#ffffff', BrandColor: '#147BD1' };

    constructor(private dropdownService: DropdownService) { }

    /* Converts a Date object to Iso date string (which is accepted by the server)*/
    convertDateToIsoString = (date: Date): string => {
        return date.toISOString();
    }

    /* Converts a iso date string (comes from server) back to a Date object*/
    convertIsoStringToDateObject = (dateString: string | Date): Date => {
        if (typeof dateString === 'string') {
            try {
                return new Date(dateString);
            }
            catch (error) {
                console.error("COT-Errorlog: error in convertIsoStringToDateObject method. " + error);
            }
        }
        else {
            if (dateString instanceof Date)
                return dateString;
            else
                return null;
        }
    }

    isIsoFromattedDateString(str: string): boolean {
        const regExpForUtcFormatttedISODateString = /T\d{2}:\d{2}:\d{2}/;
        return regExpForUtcFormatttedISODateString.test(str);
    }

    correctDate = (date: Date) => {
        if (date && date != null) {
            if (typeof date !== 'string') {
                var userTimezoneOffset = date.getTimezoneOffset() * 60 * 1000;
                if (userTimezoneOffset == 0) { }
                else if (userTimezoneOffset < 0 && date.getHours() == 0) {
                    date.setTime((date.getTime() + Math.abs(userTimezoneOffset)));
                }
                else if (userTimezoneOffset > 0 && date.getHours() == 0) {
                    date.setTime((date.getTime() - Math.abs(userTimezoneOffset)));
                }
            }
            else {
                //console.warn('date not corrected as it was in the string format !');
            }
        }
    }

    formatToTwoDecimals = (num: number): any => {
        if (isNaN(num))
            num = 0;
        return parseFloat("" + Math.round(num * 100) / 100).toFixed(2);
    }

    formatDateToEnGb(date: Date): string {
        return date.toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' });
    }

    getBrowserType = (): BrowserTypes => {
        let browserCode = null, userAgent = navigator.userAgent;
        // The order matters here, and this may report false positives for unlisted browsers.
        if (userAgent.indexOf("Firefox") > -1) {
            browserCode = BrowserTypes.FIREFOX;
            // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
        } else if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
            browserCode = BrowserTypes.OPERA;
            //"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
        } else if (userAgent.indexOf("Trident") > -1) {
            browserCode = BrowserTypes.IE;
            // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
        } else if (userAgent.indexOf("Edge") > -1) {
            browserCode = BrowserTypes.EDGE;
            // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
        } else if (userAgent.indexOf("UBrowser") > -1 || userAgent.indexOf("UCBrowser") > -1) {
            browserCode = BrowserTypes.UC;
        } else if (userAgent.indexOf("Chrome") > -1) {
            browserCode = BrowserTypes.CHROME;
            // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
        } else if (userAgent.indexOf("Safari") > -1) {
            browserCode = BrowserTypes.SAFARI;
            // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
        } else {
            // undetermined
        }
        //console.log('** browse code: ' + browserCode);
        return browserCode;
    }

    groupBy = (list, keyGetter): any => {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            if (!map.has(key)) {
                map.set(key, [item]);
            } else {
                map.get(key).push(item);
            }
        });
        return map;
    }

    public formatFooterInformation(value: string): string[] {
        if (value)
            return value.split("\r\n");
        else
            return [""];
    }

    public resetDropdown(value: number | string, options: IDropdownSelectOption[] | string[] | number[], isSelectOption: boolean) {
        this.dropdownService.reset(value, options, isSelectOption);
    }

    public getPickItemContentForChecked(isChecked: boolean, pickItems: string[]): string {
        const validCheckedValues: string[] = ['true', 't', 'yes', 'y', '1'];
        const validUncheckedvalues: string[] = ['false', 't', 'no', 'n', '0'];
        let content: string;
        if (isChecked) {
            if (pickItems.length > 0) {
                var validCheckedValue = pickItems.filter(x => validCheckedValues.indexOf(x.toLocaleLowerCase()) != -1);
                if (validCheckedValue && validCheckedValue.length > 0)
                    content = validCheckedValue[0];
                else
                    content = 'Yes';
            }
            else
                content = 'Yes';
        }
        else {
            if (pickItems.length > 0) {
                var validCheckedValue = pickItems.filter(x => validUncheckedvalues.indexOf(x.toLocaleLowerCase()) != -1);
                if (validCheckedValue && validCheckedValue.length > 0)
                    content = validCheckedValue[0];
                else
                    content = 'No';
            }
            else
                content = 'No';
        }
        return content;
    }

    public date_diff_indays(date1, date2) {
        let dt1: Date = new Date(date1);
        let dt2: Date = new Date(date2);
        return Math.ceil((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
    }

    //public diff_years(dt2: Date, dt1: Date) { // this method doesn't work and is not used
    //  var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    //  diff /= (60 * 60 * 24);
    //  return Math.abs(Math.round(diff / 365.25));
    //}

    public setFlywireTheme(theme: IFlywireTheme) {
        this.flywireTheme = theme;
    }

    public getFlywireTheme() {
        return {
            header: this.flywireTheme.Header,
            backgroundColor: this.flywireTheme.BackgroundColor,
            brandColor: this.flywireTheme.BrandColor
        }
    }

    public isUnder18(dob: Date): boolean {
        const today: Date = new Date();
        let dateObj: Date = dob;
        if (this.isIsoFromattedDateString(dob.toString())) {
            dateObj = this.convertIsoStringToDateObject(dob.toString());
        }
        let d: Date = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());//.getTime());
        d.setFullYear(d.getFullYear() + 18);
        let isUnder18: boolean = today.getTime() < d.getTime();
        // calculate age
        //let age = today.getFullYear() - dob.getFullYear();
        //if (today.getMonth() < dob.getMonth() || (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate()))
        //    age--;
        //isUnder18 = age < 18;
        return isUnder18;
    }
}

export const FillMandatoryFieldsMessage = "Please fill in the mandatory fields.";
export const MoveFromQuoteToPaymentMessage = 'When you are happy with your quote click the tick to move to the payment stage.';
export const MoveFromQuoteToRegistrationMessage = 'When you are happy with your quote click the tick to move to the registration stage.';
export const MoveFromRegistrationToPaymentMessage = "Please continue to the payment page.";
export const ContinueWithPaymentMessage = "Please continue with your payment.";

/* For different bahaviours on different devices, this classifies the device depending on the media
** type (screen size breakpoints) & User agent sting of the browser*/
@Injectable()
export class DeviceClassifier implements OnDestroy {
    isMobileDevice: boolean = null;
    customisationCode: string = 'DF';
    medialWatcher: Subscription;
    activeMediaQuery = "";

    constructor(media: ObservableMedia) {
        this.medialWatcher = media.subscribe((change: MediaChange) => {
            this.activeMediaQuery = change ? `'${change.mqAlias}' = (${change.mediaQuery})` : "";
            // TODO: add tablet ranges and define, complete that too
            if (change.mqAlias == 'xs') {
                this.isMobileDevice = true;
                //TODO: check for user agent to make user it is a real device
            }
            else {
                this.isMobileDevice = false;
            }
        });
    }

    ngOnDestroy() {
        this.medialWatcher.unsubscribe();
    }
}

@Injectable()
export class CustomerClassifier {
    public isStonyHurst: boolean = false;
    public isBishopStrow: boolean = false;
    public isDefaultSite: boolean = false;
    // Add new flags for new customers
    public customer: CustomerName = CustomerName.DEFAULT;

    setCustomerFlag = (customer: CustomerName) => {
        this.customer = customer;
        switch (customer) {
            case CustomerName.STONY_HURST:
                this.isStonyHurst = true;
                break;
            case CustomerName.BISHOPSTROW:
                this.isBishopStrow = true;
                break;
            case CustomerName.DEFAULT:
                this.isDefaultSite = true;
        }
    }
}

/* Date adaptor for Material date control to force display the dd/mm/yyyy for mat (default materia
** date picker format is mm/dd/yyyy) */
@Injectable()
export class DateFormat extends NativeDateAdapter {
    useUtcForDisplay = true;

    parse(value: any): Date | null {
        if ((typeof value === 'string') && (value.indexOf('/') > -1)) {
            const str = value.split('/');
            const year = Number(str[2]);
            const month = Number(str[1]) - 1;
            const date = Number(str[0]);
            var d = new Date(year, month, date);
            return d
        }
        const timestamp = typeof value === 'number' ? value : Date.parse(value);
        return isNaN(timestamp) ? null : new Date(timestamp);
    }
}

export enum CustomerName {
    DEFAULT = 0,
    STONY_HURST = 1,
    BISHOPSTROW = 2,
    CESC = 3,
    UKCE = 4,
    ETC = 5,
    CES_UK = 6,
    CES_IRELAND = 7,
    CES_NORTH_AMERICA = 8,
    ISLINGTON = 9,
    DEVON = 10,
    CHAMBER = 11,
    MALACA = 12,
    EUROCENTRES = 13,
    CORK = 14,
    ELC = 15,
    STUDIO_CAMBRIDGE = 16,
    HARROW_SCHOOL = 17,
}

export enum BrowserTypes {
    CHROME = 1,
    FIREFOX = 2,
    IE = 3,
    SAFARI = 4,
    EDGE = 5,
    UC = 6,
    OPERA = 7
}

// close any objects
export function cloneObject(obj) {
    var clone = {};
    for (var i in obj) {
        if (obj[i] != null && typeof (obj[i]) == "object")
            clone[i] = cloneObject(obj[i]);
        else
            clone[i] = obj[i];
    }
    return clone;
}


//
//HTMLElement.prototype.prependHtml = function (element) {
//    const div = document.createElement('div');
//    div.innerHTML = element;
//    this.insertBefore(div, this.firstChild);
//};

//HTMLElement.prototype.appendHtml = function (element) {
//    const div = document.createElement('div');
//    div.innerHTML = element;
//    while (div.children.length > 0) {
//        this.appendChild(div.children[0]);
//    }
//};



// WEBPACK FOOTER //
// ./src/app/services/common-utility.service.ts